// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Insider24Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Insider24: FC<Insider24Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
            viewBox="0 0 24 24"
        >
            <mask
                id="a"
                width="24"
                height="24"
                x="0"
                y="0"
                maskUnits="userSpaceOnUse"
                style={{ maskType: 'alpha' }}
            >
                <path d="M0 0h24v24H0z" />
            </mask>
            <g mask="url(#a)">
                <mask
                    id="b"
                    width="24"
                    height="24"
                    x="0"
                    y="0"
                    maskUnits="userSpaceOnUse"
                    style={{ maskType: 'alpha' }}
                >
                    <path d="M0 0h24v24H0z" />
                </mask>
                <g mask="url(#b)">
                    <path d="M2.625 14.025 1 12.85l5-8 3 3.5 4-6.5 3 4.5L19.375 1 21 2.175l-4.95 7.85-2.975-4.475-3.8 6.175L6.25 8.2zM14.5 18q1.05 0 1.775-.725T17 15.5t-.725-1.775T14.5 13t-1.775.725T12 15.5t.725 1.775T14.5 18m5.1 4-2.7-2.7a4 4 0 0 1-1.137.525Q15.15 20 14.5 20q-1.875 0-3.187-1.312Q10 17.375 10 15.5t1.313-3.187T14.5 11t3.188 1.313T19 15.5q0 .65-.175 1.262A4 4 0 0 1 18.3 17.9l2.7 2.7z" />
                </g>
            </g>
        </svg>
    );
};

export default Insider24;
